import { faPlus, faRobot } from "@fortawesome/pro-regular-svg-icons";

import { EmptyState } from "src/design-system/EmptyState";

type Props = {
  immutable: boolean;
  handleSelectAgent: () => void;
};

export const NoAgentSelected: React.FC<Props> = ({
  immutable,
  handleSelectAgent,
}) => (
  <EmptyState
    actionButton={{
      text: "Select Agent",
      icon: faPlus,
      onClick: handleSelectAgent,
      disabled: immutable,
    }}
    dataLoc="no-agent-selected"
    description="Select an Agent and version to configure this node"
    headline="No Agent selected"
    icon={faRobot}
  />
);
